import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SocialImpactPageComponent } from './components/social-impact-page/social-impact-page.component';
import { AdminSocialImpactComponent } from './components/admin-social-impact/admin-social-impact.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  {
    path: ':name', component: SocialImpactPageComponent, data: { title: '' }
  },
  {
    path: '',canActivate:[AdminGuard],  component: AdminSocialImpactComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SocialImpactRoutingModule { }
